<template>
  <ui-table :columns="columns" :rows="users" :row-key="(user) => user.id" :row-class="rowClass" chevron :end-label="$t('actions')" @open="(user) => $emit('open', user)">
    <template #cell-user="{ row: user }">
      <div class="ui-who">
        <ui-avatar :text="memberInitials(user)" :tone="isCourier(user) ? 'accent' : 'blue'" />
        <div>
          <b>{{ memberName(user) }}</b>
          <small>{{ user.email }}</small>
        </div>
      </div>
    </template>

    <template #cell-role="{ row: user }">
      <ui-chip :tone="isCourier(user) ? 'plain' : 'blue'">{{ roleLabel(user) }}</ui-chip>
    </template>

    <template #cell-status="{ row: user }">
      <team-status :user="user" />
      <ui-chip v-if="incomplete(user)" tone="warn" :title="`${$t('delivery_team.missing_label')} ${missingText(user)}`">{{ $t("delivery_team.status.incomplete") }}</ui-chip>
    </template>

    <template #cell-phone="{ row: user }">{{ user.phone || "—" }}</template>

    <template #cell-paying="{ row: user }">
      <template v-if="user.ptype">
        <b class="ui-num">{{ payAmountText(user, currency) }}</b>
        <small>{{ payTypeLabel(user.ptype) }}</small>
      </template>
      <span v-else class="ui-muted">{{ isCourier(user) ? $t("delivery_team.paying_unset") : "—" }}</span>
    </template>

    <template #cell-from="{ row: user }">{{ dateText(user.from) || "—" }}</template>

    <template #card="{ row: user }">
      <ui-item :tone="cardTone(user)" :active="user.id === activeId" @click="$emit('open', user)">
        <span class="ui-who">
          <ui-avatar :text="memberInitials(user)" :tone="isCourier(user) ? 'accent' : 'blue'" />
          <span>
            <b>{{ memberName(user) }}</b>
            <small>{{ user.email }}</small>
          </span>
        </span>
        <span class="ui-item__tags">
          <ui-chip :tone="isCourier(user) ? 'plain' : 'blue'">{{ roleLabel(user) }}</ui-chip>
          <team-status :user="user" />
          <ui-chip v-if="incomplete(user)" tone="warn">{{ $t("delivery_team.status.incomplete") }}</ui-chip>
        </span>
        <span v-if="user.ptype" class="ui-item__line">
          <span>{{ $t("delivery_team.col.paying") }} <b class="ui-num">{{ payFullText(user, currency) }}</b></span>
          <span v-if="user.from">{{ $t("delivery_team.col.contract_from") }} <b class="ui-num">{{ dateText(user.from) }}</b></span>
        </span>
      </ui-item>
    </template>
  </ui-table>
</template>

<script>
import hasTeamLabels from "../hasTeamLabels";
import { isIncomplete } from "../teamLogic";
import TeamStatus from "./TeamStatus.vue";

/** Lista tima (UiTable): tabela na računaru, kartice na telefonu (klasa ui-compact na korijenu bira prikaz). Red otvara karticu. */
export default {
  name: "TeamList",
  components: { TeamStatus },
  mixins: [hasTeamLabels],
  props: {
    users: { type: Array, required: true },
    activeId: { type: Number, default: 0 },
    currency: { type: String, default: "KM" },
  },
  computed: {
    columns() {
      return [
        { key: "user", label: this.$t("delivery_team.col.user") },
        { key: "role", label: this.$t("role") },
        { key: "status", label: this.$t("status") },
        { key: "phone", label: this.$t("phone"), hide: "sm", nowrap: true, cls: "ui-num" },
        { key: "paying", label: this.$t("delivery_team.col.paying") },
        { key: "from", label: this.$t("delivery_team.col.contract_from"), hide: "sm", nowrap: true, cls: "ui-num" },
      ];
    },
  },
  methods: {
    incomplete: isIncomplete,
    rowClass(user) {
      return { "is-on": user.id === this.activeId, "is-off": !user.active && !user.suspended };
    },
    /** boja lijeve trake kartice: suspendovan (crveno), nepotpun profil (upozorenje), dispečer (plavo) */
    cardTone(user) {
      if (user.suspended) return "bad";
      if (isIncomplete(user)) return "warn";
      return this.isCourier(user) ? "" : "blue";
    },
  },
};
</script>
